module.exports = __webpack_public_path__ + "img/stvrt-mapa2.916ccc0f.jpg";